import { mixed, object } from 'yup'
import { isHotDimensioningFormValid } from './utils'

/**
 * Validates the Heißbemessung multi-edit form. `elements` and `sharedSettings` are
 * kept as `mixed()` so yup never strips the live-preview data; the only rule is that
 * a Feuerwiderstandsklasse (fire_duration) must be selected when hot dimensioning is on.
 * The error is attached to the fire_duration field so the Select shows it inline.
 */
export const hotDimensioningMultiEditSchema = object({
  elements: mixed(),
  sharedSettings: mixed().test('feuerwiderstandsklasse-required', '', function (value) {
    if (isHotDimensioningFormValid(value as SettingsOnMember | undefined)) return true
    return this.createError({
      path: `${this.path}.hot_dimensioning_settings.fire_duration`,
      message: 'Bitte eine Feuerwiderstandsklasse auswählen',
    })
  }),
})
